module.exports = __webpack_public_path__ + "static/media/SORIANO.9250aa14.png";